var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/* eslint-disable indent */
import styled from 'styled-components';
export default styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", " {\n    background: ", ";\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.cssPrefix;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.page_color_background_default1;
});